
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";
	import Dialog from '@/components/dialog.vue';
	import CreateRefundAddress from './create-refund-address.vue';
	import {
		getProviderReturnLogistics,
	} from '@/api/logistics'

	@Component({
		name: 'select-refund-address',
		components: {
			'slz-dialog': Dialog,
			CreateRefundAddress
		}
	})
	export default class SelectRefundAddress extends Vue {
		@Model('change') isShow!: boolean;
		@Prop({}) private providerId!: number;
		@Prop({}) private addressId!: number;
		private showCreateRefundAddress = false;
		private showDialog = false;
		private refundPageNo = 1;
		private refundPageSize = 10;
		private refundTotal = 0;
		private refundList = [];
		private selectRA:any = {}

		@Watch('isShow')
		private onChangeShow(val) {
			this.showDialog = val
			if (val) {
				this.refundAddress()
			}
		}

		// 关闭
		private handleClose() {
			this.showDialog = false;
			this.selectRA = {}
			this.$emit('change', false)
		}

		private handleconfirm(){
			// console.log(this.selectRA.Id)
			if(!this.selectRA.Id){
				this.$message.error('请选择退货地址')
				return 
			}
			this.$emit('select', this.selectRA)
			this.showDialog = false;
		}

		// 打开创建退货地址的弹窗
		private showCreateRefund() {
			this.showCreateRefundAddress = true;
		}

		// 获取退款地址
		private async refundAddress() {
			try {
				const res: any = await getProviderReturnLogistics({
					Skip: 0,
          Take: 99999
				});
				this.refundList = res.Result.Results.map(v=>{
					v.select = v.Id == this.addressId
					if(v.select){
						this.selectRA = v
					}
					return v
				})
			} catch (e) {
				console.log(e)
			}
		}

		private handleCurrentChange(currentRow: any, oldCurrentRow: any) {
			this.refundList = this.refundList.map(v=>{
				v.select = false
				if(v.Id == currentRow.Id){
					v.select = true
					this.selectRA = v
				}
				return v
			})
			this.$forceUpdate()
		}
	}
